import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Helper to check if supabase is configured
export const isSupabaseConfigured = () => {
  return supabaseUrl && supabaseKey && !supabaseUrl.includes('YOUR_SUPABASE') && !supabaseUrl.includes('YOUR_PROJECT');
};

// Only create client if valid credentials are provided
export const supabase = isSupabaseConfigured() 
  ? createClient(supabaseUrl, supabaseKey)
  : null;
